import Class from '../../models/Class'
import requestAction from '../../utils/requestAction'

export const FETCH_CLASS = 'FETCH_CLASS'

export default (id: number, handleResponse?: (cls: Class) => void) => requestAction(FETCH_CLASS)(`class?classId=${id}`, 'GET', undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(new Class(response.class)) }
)